import React from 'react';
import SpirisIcon from '../Icon/SpirisIcon';

const Chip = ({ label, onRemove }) => {
  return (
    <div className="combobox-selected">
      <span className="combobox-selected-label" title={label}>{label}</span>
      
      {onRemove && (
        <button className="clear-btn bg-transparent align-items-center" type="button" aria-label="Delete selected option" onClick={onRemove}>
          <SpirisIcon name="close" size="sm" className="icon-neutral" />
        </button>
      )}
    </div>
  );
};

export default Chip;
